
const state = () => ({
  /**
   * Settings dialog visibility.
   * @type Boolean
   */
  show: false,

  /**
   * This variable contains all the device settings.
   * @type Object
   */
  values: {
    cashier: 1,
    tablePriceId: 1,
    rememberDishOrder: true,
    keepOrdersOpen: false,
    fastMenuEntry: false,
    hideMenuContents: true,
  },
})

const getters = {}

const mutations = {
  show (state) {
    state.show = true
  },
  hide (state) {
    state.show = false
  },
  set (state, v) {
    state.values = {...state.values, ...v}
  },
}

const actions = {
  open ({ commit }) {
    setTimeout(() => commit('show'), 150)
  },
  close ({ commit }) {
    commit('hide')
  },
  load ({ commit, dispatch }) {
    const settings = localStorage.getItem('settings')
    if (!! settings) {
      commit('set', JSON.parse(settings))
    }
  },
  save ({ commit, dispatch }, values) {
    commit('set', values)
    const settings = JSON.stringify(values)
    localStorage.setItem('settings', settings)
    dispatch('$log', `Saved settings: ${settings}`, { root: true })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
